import AuthHeader from "../../authentication/authHeader";
import FormInputItem, {
    resetPasswordFormItems,
} from "../../common/form/formInput/formInput";
import ForgotPasswordFormStep from "../forgotPasswordFormStep/forgotPasswordFormStep";
import FormButton from "./../../common/form/formButton";
import { resetPassword } from "../../../services/services";
import { useContext } from "react";
import { ForgotPasswordContext } from "../../../context/forgotPasswordContext";

const NewPasswordFormHeader = () => {
    return (
        <AuthHeader title='Resetear contraseña'>
            <p className='forgotPassword-text'>Ingresá una nueva contraseña</p>
        </AuthHeader>
    );
};

const NewPasswordForm = () => {
    const { recoveryByCuit, value } = useContext(ForgotPasswordContext);
    const newPassword = (values) => {
		const {email,cuit} = recoveryByCuit ? {email:null,cuit:value} : {email:value,cuit:null};
		return resetPassword({email,cuit}, values.password);
	};

    return (
        <ForgotPasswordFormStep
            FormStepHeader={<NewPasswordFormHeader />}
            formStepCallback={newPassword}
        >
            <div style={{ width: "350px" }}>
                {resetPasswordFormItems.map((item) => (
                    <FormInputItem key={item.name} item={item} />
                ))}
                <FormButton> Resetear Contraseña</FormButton>
            </div>
        </ForgotPasswordFormStep>
    );
};
export default NewPasswordForm;
